import React from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import ProductCard from '../ProductCards/ProductCard';
import styled from 'styled-components';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { cells, grid } from '../../styling/utils/grid';
import { translate } from '../../Services/translation';
import { section } from '../../styling/utils/grid';

const StyledWistListWrapper = styled.div<{ $numPerRow: number }>`
  ${grid};
  ${cells(2)}
  gap: 0.6rem;
  grid-auto-rows: 1fr; /* Set the row height to 1 fractional unit (equal height) */
  ${breakpoint('large')} {
    ${(p) => cells(p.$numPerRow)}
  }
  margin: 1rem;
  ${breakpoint('large')} {
    ${section}
  }
`;

const EmptyWishListWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5rem;
  ${breakpoint('large')} {
    ${section}
  }
`;

const WishList = () => {
  const { items } = useTypedSelector((state) => state.wishList);

  if (!items || items.length === 0) {
    return (
      <EmptyWishListWrapper>
        <h4>{translate('wishlist.emptyMessage')}</h4>
      </EmptyWishListWrapper>
    );
  } else {
    return (
      <StyledWistListWrapper $numPerRow={4}>
        {items?.map((item) => (
          <ProductCard key={item.id} product={item.product} />
        ))}
      </StyledWistListWrapper>
    );
  }
};

export default WishList;
